/**
 * ELF-CIRCLE landing page.
 *
 * Stacks the page sections in the order they appear on the design canvas.
 * Every section is a full-screen band — see `.elf-band` in elf-landing.css.
 * The first two are joined by the paper tear in ElfTear.
 * Palette, theme bar and CMS provider live in ElfShell.
 */

import React from 'react';
import ElfEvents from './ElfEvents';
import ElfFooter from './ElfFooter';
import ElfHeroPicker from './ElfHeroPicker';
import ElfMerch from './ElfMerch';
import ElfScheduler from './ElfScheduler';
import ElfServices from './ElfServices';
import ElfShell from './ElfShell';
import ElfSocial from './ElfSocial';
import ElfSponsors from './ElfSponsors';
import ElfTear from './ElfTear';

export const ElfLanding: React.FC = () => (
  <ElfShell>
    {/* The hero tears down the middle on scroll to uncover the services rail. */}
    <ElfTear hero={<ElfHeroPicker />}>
      <ElfServices />
    </ElfTear>
    <ElfScheduler />
    <ElfEvents />
    <ElfMerch />
    <ElfSocial />
    <ElfSponsors />
    <ElfFooter />
  </ElfShell>
);

export default ElfLanding;
